import { useAtom } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { feePayersGenerationIdAtom, sendYearlyFeePaymentEmailsIdAtom, yearlyFeePaymentsGenerationIdAtom } from '@/state'
import FeePayersGeneration from './fee-payers-generation'
import YearlyFeePaymentsGeneration from './yearly-fee-payments-generation'
import SendYearlyFeePaymentEmails from './send-yearly-fee-payment-emails'
import FeePayersGenerationStatus from './fee-payers-generation-status'
import YearlyFeePaymentsGenerationStatus from './yearly-fee-payments-generation-status'
import SendYearlyFeePaymentEmailsStatus from './send-yearly-fee-payment-emails-status'

function YearlyFeeCollectionMassActions({
    yearlyFeeCollectionId,
} : {
    yearlyFeeCollectionId: number,
}) {

    const [feePayersGenerationId, setFeePayersGenerationId] = useAtom(feePayersGenerationIdAtom)
    const [yearlyFeePaymentsGenerationId, setYearlyFeePaymentsGenerationId] = useAtom(yearlyFeePaymentsGenerationIdAtom)
    const [sendYearlyFeePaymentEmailsId, setSendYearlyFeePaymentEmailsId] = useAtom(sendYearlyFeePaymentEmailsIdAtom)

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2,
            pb: 3,
        }}>
            <Box sx={(theme) => ({
                border: `1px solid ${theme.palette.customRed.light}`,
                backgroundColor: '#fff8f8',
                p: 2,
                borderRadius: 2.5,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            })}>
                <Typography variant="h4" component="h2" textAlign="center">
                    Hromadné operace na všech poplatnících
                </Typography>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}>
                    {feePayersGenerationId &&
                        <FeePayersGenerationStatus
                            jobId={feePayersGenerationId}
                            handleClose={() => setFeePayersGenerationId(null)}
                        />
                    }
                    {yearlyFeePaymentsGenerationId &&
                        <YearlyFeePaymentsGenerationStatus
                            jobId={yearlyFeePaymentsGenerationId}
                            handleClose={() => setYearlyFeePaymentsGenerationId(null)}
                        />
                    }
                    {sendYearlyFeePaymentEmailsId &&
                        <SendYearlyFeePaymentEmailsStatus
                            jobId={sendYearlyFeePaymentEmailsId}
                            handleClose={() => setSendYearlyFeePaymentEmailsId(null)}
                        />
                    }
                </Box>
                <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1,
                }}>
                    <FeePayersGeneration
                        yearlyFeeCollectionId={yearlyFeeCollectionId}
                    />
                    <YearlyFeePaymentsGeneration
                        yearlyFeeCollectionId={yearlyFeeCollectionId}
                    />
                    <SendYearlyFeePaymentEmails
                        yearlyFeeCollectionId={yearlyFeeCollectionId}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default YearlyFeeCollectionMassActions
